<template>
  <div class="user-task-layer" :class="[`step-${curStep}`]" v-show="viewType === 'task'">
    <!-- <button class="next" @click="nextStep">next</button> -->
    <tip v-if="isDialogVisible" :step="curStep"></tip>
    <template v-if="curStep === 0">
      <div class="cover-all block" ref="coverAll"></div>
    </template>
    <template v-if="curStep === 1">
      <div class="left block" ref="left"></div>
      <div class="middle block" ref="middle"></div>
      <div class="right block" ref="right"></div>
    </template>
    <template v-if="curStep === 2">
      <div class="left block" ref="left"></div>
      <div class="top block" ref="top"></div>
      <div class="right block" ref="right"></div>
      <div class="bottom block" ref="bottom"></div>
    </template>
    <template v-if="curStep === 3">
      <div class="top block" ref="top"></div>
      <div class="right block" ref="right"></div>
    </template>
    <template v-if="curStep === 4">
      <div class="left block" ref="left"></div>
      <div class="middle block" ref="middle"></div>
      <div class="right block" ref="right"></div>
    </template>
    <template v-if="curStep === 5">
      <div class="top block" ref="top"></div>
      <div class="right block" ref="right"></div>
    </template>
    <template v-if="curStep === 6">
      <div class="cover-all block" ref="coverAll"></div>
      <div class="sound-btn" ref="soundBtn">
        <i class="iconfont iconzimuhepeile"></i>
        声音与字幕
      </div>
      <div class="preview-btn" ref="previewBtn">预览</div>
      <div class="export-btn" ref="exportBtn">导出</div>
    </template>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import tip from './userTaskTip.vue';
export default {
  components: {
    tip
  },
  data () {
    return {
      isDialogVisible: false,
      stage: 'doing'
    }
  },
  computed: {
    isDoing () {
      return this.stage === 'doing';
    },
    ...mapGetters({
      viewType: 'userTask/viewType',
      TOOL: 'TOOL'
    }),
    curStep: {
      get() {
        return this.$store.getters['userTask/step'];
      },
      set(val) {
        this.$store.commit('userTask/setStep', val);
      }
    }
  },
  watch: {
    'TOOL.selectedScenes.nowTime' (val) {
      console.log(`Turbo ~ val`, val)
    },
    'TOOL.selectedScenes' (val, old) {
      if (this.curStep === 5 && val && val.index === 1 && old && old.index === 0) {
        this.nextStep();
      }
    }
  },
  created () {
    window.addEventListener('resize', this.onResize);
    this.$bus.on("updateAllScenes", this.onDraftLoaded);
    this.$bus.on('userTaskStep', this.onUserTaskStep);
    this.$bus.on("addCanvas", this.onSpriteAdded);
    eve.on("changeTextOption", this.onTextChange);
    eve.on('undo_redo', this.onEffectUpdated);
  },
  mounted () {
    this.curStep = 0;
    this.$nextTick(() => {
      this.prepareStep0();
    });
  },
  beforeDestroy () {
    window.addEventListener('resize', this.onResize);
    this.$bus.off("updateAllScenes", this.onDraftLoaded);
    this.$bus.off('userTaskStep', this.onUserTaskStep);
    this.$bus.off("addCanvas", this.onSpriteAdded);
    eve.off("changeTextOption", this.onTextChange);
    eve.off('spriteEle.updateEffect', this.onEffectUpdated);
  },
  methods: {
    onResize () {
      clearTimeout(this.tid);
      this.tid = setTimeout(() => {
        const run = this[`prepareStep${this.curStep}`];
        run && run.call(this);
      }, 800);
    },
    onDraftLoaded () {
      this.isDialogVisible = true;
      this.curStep = 1;
      this.$nextTick(() => {
        this.prepareStep1();
      });
    },
    nextStep () {
      this.curStep += 1;
      this.$nextTick(() => {
        const run = this[`prepareStep${this.curStep}`];
        run && run.call(this);
      })
    },
    setPosByTimeline () {
      const layerRect = this.$el.getBoundingClientRect();
      const timelineRect = $('#time-control')[0].getBoundingClientRect();
      const handlerRect = $('.rc-slider-handle')[0].getBoundingClientRect();
      const lr = layerRect;
      const tr = timelineRect;
      const leftBlock = {
        w: tr.left - lr.left,
        h: layerRect.height,
        l: 0,
        t: 0
      };
      const middleBlock = {
        w: timelineRect.width,
        h: timelineRect.top - lr.top + 72,
        l: timelineRect.left - lr.left,
        t: 0
      }
      const rightBlock = {
        w: lr.width - leftBlock.w - middleBlock.w,
        h: lr.height,
        l: leftBlock.w + middleBlock.w,
        t: 0
      }
      if (this.curStep === 1) {
        this.dialogPos = {
          l: handlerRect.left - lr.left - 86,
          t: middleBlock.h - 124 - 211
        }
        const dp = this.dialogPos;
        $('.user-task-tip').css({left: dp.l, top: dp.t});
      }
      if (this.curStep === 4) {
        const lineEle = $('.timeline-drag-left')[0];
        let left = handlerRect.left;
        if (lineEle) {
          const lineRect = lineEle.getBoundingClientRect();
          left = lineRect.left;
        }
        this.dialogPos = {
          l: left - lr.left - 86 - 30,
          t: middleBlock.h - 194 - 211
        }
        const dp = this.dialogPos;
        $('.user-task-tip').css({left: dp.l, top: dp.t});
      }
      $(this.$refs.left).css({width: leftBlock.w, height: leftBlock.h, left: leftBlock.l, top: leftBlock.t});
      $(this.$refs.middle).css({width: middleBlock.w, height: middleBlock.h, left: middleBlock.l, top: middleBlock.t});
      $(this.$refs.right).css({width: rightBlock.w, height: rightBlock.h, left: rightBlock.l, top: rightBlock.t});
    },
    setPosByCanvas () {
      const layerRect = this.$el.getBoundingClientRect();
      const canvasRect = $('#editor>div')[1].getBoundingClientRect();
      const lr = layerRect;
      const cr = canvasRect;
      const leftBlock = {
        w: cr.left - lr.left,
        h: lr.height,
        l: 0,
        t: 0
      }
      const topBlock = {
        w: cr.width,
        h: cr.top - lr.top,
        l: leftBlock.w,
        t: 0
      };
      const rightBlock = {
        w: lr.width - leftBlock.w - topBlock.w,
        h: lr.height,
        l: leftBlock.w + topBlock.w,
        t: 0
      };
      const bottomBlock = {
        w: topBlock.w,
        h: lr.height - topBlock.h - cr.height,
        l: leftBlock.w,
        t: topBlock.h + cr.height
      }
      if (this.curStep === 2) {
        const textSprite = this.TOOL.selectedScenes.sprites.find(v => v.type === 'Text');
        console.log(`Turbo ~ setPosByCanvas ~ textSprite`, textSprite)
        const textEle = $(`#sprite-${textSprite.id}`)[0];
        const textRect = textEle.getBoundingClientRect();
        this.dialogPos = {
          l: textRect.left - lr.left + textRect.width / 2,
          t: textRect.top - lr.top + textRect.height,
        }
        const dp = this.dialogPos;
        $('.user-task-tip').css({left: dp.l, top: dp.t});
      }
      $(this.$refs.left).css({width: leftBlock.w, height: leftBlock.h, left: leftBlock.l, top: leftBlock.t});
      $(this.$refs.top).css({width: topBlock.w, height: topBlock.h, left: topBlock.l, top: topBlock.t});
      $(this.$refs.right).css({width: rightBlock.w, height: rightBlock.h, left: rightBlock.l, top: rightBlock.t});
      $(this.$refs.bottom).css({width: bottomBlock.w, height: bottomBlock.h, left: bottomBlock.l, top: bottomBlock.t});
    },
    setPosBySceneBar() {
      const layerRect = this.$el.getBoundingClientRect();
      const barRect = $('.scene-area>div>.inner')[0].getBoundingClientRect();
      const lr = layerRect;
      const br = barRect;
      const topBlock = {
        w: lr.width,
        h: br.top - lr.top,
        l: 0,
        t: 0
      };
      const rightBlock = {
        w: lr.width - (br.right - lr.left),
        h: lr.height - topBlock.h,
        l: br.right - lr.left,
        t: topBlock.h
      }
      if (this.curStep === 3) {
        this.dialogPos = {
          l: rightBlock.l + 8,
          t: topBlock.h + rightBlock.h / 2 - 200
        }
      }
      if (this.curStep === 5) {
        this.dialogPos = {
          l: rightBlock.l + 8,
          t: topBlock.h + rightBlock.h / 2 + 50
        }
      }
      const dp = this.dialogPos;
      $('.user-task-tip').css({left: dp.l, top: dp.t});

      $(this.$refs.top).css({width: topBlock.w, height: topBlock.h, left: topBlock.l, top: topBlock.t});
      $(this.$refs.right).css({width: rightBlock.w, height: rightBlock.h, left: rightBlock.l, top: rightBlock.t});
    },
    setPosCoverAll(lr) {
      $(this.$refs.coverAll).css({width: lr.width, height: lr.height, left: 0, top: 0});
    },
    prepareStep0() {
      const layerRect = this.$el.getBoundingClientRect();
      this.setPosCoverAll(layerRect);
    },
    prepareStep1() {
      this.setPosByTimeline();
    },
    prepareStep2() {
      this.setPosByCanvas();
    },
    prepareStep3() {
      this.setPosBySceneBar();
      this.$bus.emit("materialPane_vue", { type: "characters" });
    },
    prepareStep4() {
      this.setPosByTimeline();
    },
    prepareStep5() {
      this.setPosBySceneBar();
      this.$bus.emit("materialPane_vue", { type: "scenes" });
    },
    prepareStep6() {
      const layerRect = this.$el.getBoundingClientRect();
      const soundBtnRect = $('.editorBtn .btn-sound')[0].getBoundingClientRect();
      const pr = $('.TopNav .play-btn')[0].getBoundingClientRect();
      const er = $('.TopNav .export-btn')[0].getBoundingClientRect();
      const sr = soundBtnRect;
      const lr = layerRect;
      const soundBtnPos = {
        l: sr.left - lr.left,
        t: sr.top - lr.top,
      };
      const pPos = {
        l: pr.left - lr.left,
        t: pr.top - lr.top
      };
      const ePos = {
        l: er.left - lr.left,
        t: er.top - lr.top
      };
      const l = lr.width - 218 - 350;
      const t = 157;
      $('.user-task-tip').css({left: l, top: t});
      this.setPosCoverAll(lr);
      $(this.$refs.soundBtn).css({left: soundBtnPos.l, top: soundBtnPos.t, width: 112, height: 34});
      $(this.$refs.previewBtn).css({left: pPos.l, top: pPos.t, width: 80, height: 36});
      $(this.$refs.exportBtn).css({left: ePos.l, top: ePos.t, width: 80, height: 36});
    },
    onUserTaskStep() {
      if (this.curStep === 1) {
        const time = this.TOOL.selectedScenes.nowTime;
        if (time >= 2.5 && time <= 3.5) {
          this.nextStep();
        }
      }
    },
    onTextChange(textSprite) {
      textSprite;
      if (this.curStep === 2) {
        this.nextStep();
      }
    },
    onSpriteAdded(sprite) {
      const isCharacter = sprite && sprite.option && [10, 118, 100, 57].includes(sprite.option.fileType);
      if (isCharacter && this.curStep === 3) {
        this.nextStep();
      }
    },
    onEffectUpdated({type, data: {reData, changeData}}) {
      if (this.curStep === 4 && type === 'timeline_drag') {
        const start = changeData[0].data.entranceAnim.start;
        const oldStart = reData[0].data.entranceAnim.start;
        if (start !== oldStart) {
          this.nextStep()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.next {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
.step-1 {
  .tip {
    position: absolute;
    width: 350px;

  }
}
.dialog {
  position: absolute;
  z-index: 10;
  width: 350px;
  min-height: 124px;
  background: #FFFFFF;
  border-radius: 4px;
}
.user-task-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#ff0000, .0);
  z-index: 2147483647;
  pointer-events: none;
  & * {
    pointer-events: initial;
  }
}
.block {
  position: absolute;
  background: rgba(#000000, .6);
}

.sound-btn {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 34px;
  background: #fafaff;
  box-shadow: 0px 3px 6px rgba(197, 197, 197, 0.16);
  border: 1px solid #fafaff;
  border-radius: 4px;
  color: #474261;
  & > .iconfont {
    font-size: 16px;
    margin-right: 2px;
  }
}
.preview-btn, .export-btn {
  position: absolute;
  line-height: 36px;
  border-radius: 4px;
  color: #fff;
  background-color: #5778fb;
}
</style>



// WEBPACK FOOTER //
// src/components/userTask/userTaskLayer.vue